export enum activeStyle {
  generelAnvendelse = 'generelAnvendelse',
  etagerByggeHojde = 'etagerByggeHojde',
  bygOmfang = 'bygOmfang',
  planensAlder = 'planensAlder',
}

export interface IAppState {
  filterToggled: IFilterToggleState;
  searchResult: ISearchResultState;
  lokalplaner: ILokalplanState;
  filters: IFiltersState;
  style: IStyleState;
  clickedPlan: IClickedPlanState;
}

export interface ISearchResultState {
  hovered: number;
}
export interface ILokalplanState {
  triggerHistoriskeLokalplaner: boolean;
}
export interface IFiltersState {
  generelAnvendelse: Array<number>;
  specifikAnvendelse: Array<number>;
  planensAlder: Array<number>;
  bygOmfang: IBygOmfangFilter;
  etagerByggeHojde: IEtagerByggehojdeFilter;
}
export interface IBygOmfangFilter {
  selectedFilter: BygOmfangFilter;
  filter: Array<number>;
}
export enum BygOmfangFilter {
  bebyggelsesProcent = 'bebyggelsesProcent',
  etageMeter = 'etageMeter',
  rumfang = 'rumfang',
}
export interface IEtagerByggehojdeFilter {
  selectedFilter: EtagerByggeHojdeFilter;
  filter: Array<number>;
}
export enum EtagerByggeHojdeFilter {
  byggeHojde = 'byggeHojde',
  antalEtager = 'antalEtager',
}
export interface IStyleState {
  activeStyle: activeStyle;
}

export interface IFilterToggleState {
  anvendelse: boolean;
  maxHojde: boolean;
  maxBygpct: boolean;
  planensAlder: boolean;
}

export interface IClickedPlanState {
  delomraade: number;
  byggefelt: number;
}
